<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="coolrunner"
          :icon="icon"
          inline
          class="px-5 py-3"
        >
          <template v-slot:after-heading>
            <div class="text-h2 font-weight-light">
              {{ $t('districts') }}
            </div>
          </template>

          <v-data-table
            v-model="selected"
            :items="selectableDistricts"
            :headers="districtsHeaders"
            dense
            :loading="loading"
            item-key="district"
            selectable-key="selectable"
            show-select
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.calculated="{item}">
              {{ caclulatingDistricts[item.district.replace(/ /g, '_')] }}
            </template>
            <template v-slot:item.calculating_route="{item}">
              <v-progress-circular
                v-if="item.calculating_route"
                size="16"
                width="2"
                indeterminate
                color="green"
              />

              <v-icon
                v-else
                color="red"
              >
                not_interested
              </v-icon>
            </template>
            <template v-slot:item.actions="{item}">
              <v-btn
                :disabled="!item.calculating_route"
                @click="recalculate(item.district)"
              >
                {{ $t('recalculate') }}
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-col>
                <v-divider />
                <v-row
                  justify="space-between"
                  align="center"
                >
                  <v-col
                    cols="8"
                  >
                    <v-menu
                      ref="date-menu"
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      max-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="mt-5"
                          dense
                          :value="date || $t('today')"
                          :label="$t('delivery_date')"
                          v-on="on"
                        />
                      </template>

                      <v-date-picker v-model="date" />
                    </v-menu>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      :disabled="selected.length <= 0"
                      color="primary"
                      class="ml-auto"
                      @click="calculateSelected"
                    >
                      {{ $t('calculate') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
      <v-col cols="12">
        <base-material-card
          color="coolrunner"
          :icon="icon"
          inline
          class="px-5 py-3"
        >
          <template v-slot:after-heading>
            <div class="text-h2 font-weight-light">
              {{ $t('planned_routes') }}
            </div>
          </template>
          <v-data-table
            :items="plannedRoutes"
            :headers="plannedRoutesHeaders"
            dense
            :loading="loadingRoutes"
            item-key="route"
            disable-pagination
            hide-default-footer
            @current-items="fixRowColors()"
          >
            <template v-slot:item.route="{item}">
              <div :class="isRouteToday(item.route) && 'today'">
                {{ item.route }}
              </div>
            </template>
            <template v-slot:item.actions="{item}">
              <v-btn @click="getRouteLabel(item.route)">
                {{ $t('label') }}
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
    <base-loading-overlay :loading="loadingPdf" />
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Auth from '@/mixins/Auth'
  import { handleErrorResponse } from '@/plugins/data'
  import print from 'print-js'
  import { PCN } from '../../../utils/constants'

  export default {
    mixins: [Auth],
    data () {
      return {
        crudl: {
          C: PCN.val,
          R: PCN.val,
          U: PCN.val,
          D: PCN.val,
          L: PCN.val,
          COOLRUNNER_ONLY: false,
        },
        useDev: false,
        endpoint: 'homerunner',
        name: 'dg',
        icon: 'mdi-truck-fast-outline',
        districtsHeaders: [
          {
            sortable: false,
            text: this.$t('district'),
            value: 'district',
            width: '100%',
          },
          {
            sortable: false,
            align: 'center',

            text: this.$t('count'),
            value: 'packages',
          },
          {
            sortable: false,
            align: 'center',
            text: this.$t('loaded'),
            value: 'calculated',
          },
          {
            sortable: false,
            align: 'center',
            text: this.$t('calculating'),
            value: 'calculating_route',
          },
          {
            value: 'actions',
          },
        ],
        plannedRoutesHeaders: [
          {
            sortable: false,
            text: this.$t('route'),
            value: 'route',
          },
          {
            sortable: false,
            text: this.$t('district'),
            value: 'district',
            width: '100%',
          },
          {
            sortable: false,
            text: this.$t('count'),
            value: 'packages',
          },
          {
            sortable: false,
            text: this.$t('pickups'),
            value: 'pickup',
          },
          {
            sortable: false,
            text: this.$t('deliveries'),
            value: 'delivery',
          },
          {
            sortable: false,
            text: this.$t('carrier'),
            value: 'hr_carrier',
          },
          {
            sortable: false,
            text: this.$t('eta'),
            value: 'eta',
          },
          {
            sortable: false,
            text: this.$t('calculated_at'),
            value: 'route_calculated_at',
          },
          {
            align: 'right',
            value: 'actions',
          },
        ],
        districts: [],
        plannedRoutes: [],
        selected: [],
        loading: false,
        loadingRoutes: false,
        loadingPdf: false,
        dateMenu: null,
        date: null,
        cancelToken: null,
        cancelTokenRoutes: null,
        caclulatingDistricts: { },
      }
    },
    computed: {
      selectableDistricts: function () {
        return this.$_.map(this.districts, d => ({ ...d, selectable: !d.calculating_route }),
        )
      },
    },
    destroyed: function () {
      this.districts.forEach(dis => {
        const channel = `tms_route.${dis.district.replace(/ /g, '_')}`
        const event = '.calculating'

        this.$echo.private(channel)
          .stopListening(event)
      })
    },

    created: function () {
      this.fetchDistricts()
      this.fetchRoutes()
    },
    methods: {
      setupDistrictSockets () {
        this.districts.forEach(dis => {
          const channel = `tms_route.${dis.district.replace(/ /g, '_')}`
          const event = '.calculating'

          this.$echo.private(channel)
            .listen(event, (d) => {
              const { data } = d
              const cds = { ...this.caclulatingDistricts }
              cds[dis.district.replace(/ /g, '_')] = data.count
              this.caclulatingDistricts = cds
            })
        })
      },
      fetchDistricts () {
        if (!this.canList()) { return }

        if (this.cancelToken) { this.cancelToken.cancel('cancelled') }
        this.cancelToken = axios.CancelToken.source()

        this.loading = true

        this.$get(`/${this.endpoint}/districts`, { cancelToken: this.cancelToken.token }, { useDev: this.useDev })
          .then(response => {
            this.districts = response.data.data
            this.setupDistrictSockets()
            this.loading = false
          })
          .catch(e => {
            if (e !== 'cancelled') this.loading = false
          })
      },
      fetchRoutes () {
        if (!this.canList()) { return }

        if (this.cancelTokenRoutes) { this.cancelTokenRoutes.cancel('cancelled') }
        this.cancelTokenRoutes = axios.CancelToken.source()

        this.loadingRoutes = true

        this.$get(`/${this.endpoint}/planned-routes`, { cancelToken: this.cancelTokenRoutes.token }, { useDev: this.useDev })
          .then(({ data }) => {
            this.plannedRoutes = data.response_data.data
            this.loadingRoutes = false
          })
          .catch(e => {
            if (e !== 'cancelled') this.loadingRoutes = false
          })
      },
      recalculate: function (district) {
        this.loading = true
        this.$put(`/${this.endpoint}/recalculate`, { districts: [district], date: this.date }, { useDev: this.useDev })
          .then(({ data }) => {
            this.$toast('Rute genberegnes')
            this.selected = []
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },

      calculateSelected: function () {
        this.loading = true
        this.$put(`/${this.endpoint}/calculate`, { districts: this.$_.map(this.selected, 'district'), date: this.date }, { useDev: this.useDev })
          .then(({ data }) => {
            this.$_.each(this.selected, district => {
              district.calculating_route = true
            })
            this.selected = []
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },

      getRouteLabel: function (route) {
        this.loadingPdf = `${this.$t('fetching_label')}...`
        this.$get(`/homerunner/route/${route}/label`, {}, { responseType: 'blob' })
          .then(r => {
            print({
              printable: URL.createObjectURL(r.data),
              type: 'pdf',
              onPrintDialogClose: () => { this.loadingPdf = null },
              onPdfOpen: () => { this.loadingPdf = null },
              onError: handleErrorResponse,
            })
          })
          .catch(e => {
            this.loadingPdf = null
          })
      },
      str_pad: function (n) {
        return String(`00${n}`).slice(-2)
      },
      isRouteToday: function (route) {
        var now = new Date()
        const dateString = `${now.getFullYear()}${this.str_pad(now.getMonth() + 1)}${this.str_pad(now.getDate())}`
        const routeDate = route.substring(0, 8)
        return dateString === routeDate
      },
      fixRowColors: function () {
        setTimeout(() => {
          const rows = document.querySelectorAll('table tbody tr')
          rows.forEach(x => {
            const special = x.querySelector('div.today')
            if (special) {
              x.classList.add('today')
            }
          })
        }, 200)
      },
    },
  }
</script>

<style lang="sass">
tr.today
  background-color: rgba(162, 234, 167)

</style>
